export default {
  bind(el) {
    el.addEventListener('dragover', addClasses, false);
    el.addEventListener('dragleave', removeClasses, false);
    el.addEventListener('drop', removeClasses, false);
  },

  unbind(el) {
    el.removeEventListener('dragover', addClasses, false);
    el.removeEventListener('dragleave', removeClasses, false);
    el.removeEventListener('drop', removeClasses, false);
  },
};

export function addClasses(e) {
  e.preventDefault();
  e.stopPropagation();

  if (
    e.dataTransfer.types &&
    (e.dataTransfer.types[0] === 'Files' ||
      e.dataTransfer.types[0] === 'application/x-moz-file')
  ) {
    this.classList.add(this.dataset.dropClass);
  }
}

export function removeClasses(e) {
  e.preventDefault();
  e.stopPropagation();
  this.classList.remove(this.dataset.dropClass);
}
